exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/index.js??postcss!../common.css"), "");

// module
exports.push([module.id, "\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/new-offer/new-offer.component.css
// module id = ../../../../../src/app/new-offer/new-offer.component.css
// module chunks = main